export default __webpack_public_path__ + "static/media/Group 6389@3x.9d1f50f1.png";